module.exports = __webpack_public_path__ + "static/media/logo-turismo-rc-white.c4a983b9.svg";